import logo from "../../../assets/images/logo/Trellis_Logomark_color.png";
import axios from "axios";
import { Button } from "../../../components/core/basic/Button";
import Card from "../../../components/core/basic/Card";
import { Component } from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { withRouter } from "../../../hocs/withRouter";
import { getURLPrefix } from "../../../utils/getUrlPrefix";
import { SUBSCRIPTION_PLANS_UPPERCASE } from "../../../utils/onboardingConstants";
import * as Sentry from "@sentry/react";
import api from "../../../utils/api";
import checkModule from "../../../utils/checkModule";
import { selectModules } from "../../../redux/selectors/modules";
import { formatCurrency } from "../../../utils/formatNumber";
import { css } from "../../../../styled-system/css";
import { Grid, HStack, VStack } from "../../../../styled-system/jsx";
import Loading from "../../../components/core/blocks/Loading";
import ModalAlert from "../../../components/core/basic/ModalAlert";
import { Modal } from "../../../components/core/basic/Modal";

const subscriptionPlans = SUBSCRIPTION_PLANS_UPPERCASE;

const URL_PREFIX = getURLPrefix();

class SubscriptionPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subList: [],
      subName: "",
      signUpDate: "",
      subSuccessful: false,
      reactivateActive: false,
      error: {},
      changePlanModal: !!this.props.location?.state?.showModal,
      currentTier: "",
      currentPricingTier: "",
      currentAnalyticsTier: "",
      upgradedSubscriptionPlanName: "",
      upgradedPricingSubscriptionPlanName: "",
      upgradedAnalyticsSubscriptionPlanName: "",
      subscriptionPlan: null,
      pricingSubscriptionPlan: null,
      analyticsSubscriptionPlan: null,
      subscriptionPlanName: "",
      pricingSubscriptionPlanName: "",
      analyticsSubscriptionPlanName: "",
      payAmount: "",
      payPlan: "",
      pricingPayPlan: "",
      analyticsPayPlan: "",
      payFrequency: "",
      upgradedPayPlan: "",
      upgradedPricingPayPlan: "",
      upgradedAnalyticsPayPlan: "",
      monthlyChecked: true,
      numOfShelves:
        this.props.location?.state?.numOfShelves ?
          this.props.location?.state?.numOfShelves
        : this.props.currentNumOfShelves,
      currentNumOfShelves:
        this.props.location?.state?.numOfShelves ?
          this.props.location?.state?.numOfShelves
        : this.props.currentNumOfShelves,
      monthlyShelfFee: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? this.props.monthlyShelfFee : 0,
      includedShelves: 0,
      numOfActiveShelves: 0,
      upgradeTarget: "advertising",
    };
  }

  fetchActiveShelfCount = async () => {
    try {
      const res = await api.get("/api/shelves");
      this.setState({ numOfActiveShelves: res.data.count });
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  componentDidMount() {
    if (
      this.props.amz_onboard.org_status === "trial_active" ||
      this.props.amz_onboard.org_status === "trial_expired" ||
      this.props.amz_onboard.org_status === "pre_trial" ||
      this.props.amz_onboard.org_status === "qore_active"
    ) {
      // do nothing
    } else {
      this.getSubscriptionList();
      this.getSubscriptionName();
      this.getSignUpDate();

      if (checkModule(this.props.modules, "SEARCH_ANALYTICS")) {
        this.fetchActiveShelfCount();
      }
    }
  }

  componentDidUpdate() {
    if (
      (checkModule(this.props.modules, "SEARCH_ANALYTICS") &&
        this.state.currentNumOfShelves !== this.props.currentNumOfShelves) ||
      this.state.monthlyShelfFee !== this.props.monthlyShelfFee
    ) {
      // oxlint-disable-next-line react/no-did-update-set-state
      this.setState({
        currentNumOfShelves: this.props.currentNumOfShelves,
        numOfShelves: this.props.currentNumOfShelves,
        monthlyShelfFee: this.props.monthlyShelfFee,
      });
    }
  }

  getSignUpDate = () => {
    axios
      .get(URL_PREFIX + "/api/billing/plan")
      .then((res) => {
        this.setState({ signUpDate: res.data.sign_up_date });
      })
      .catch((error) => {
        if (error?.response?.status !== 400) {
          Sentry.captureException(error);
        }
      });
  };

  getDisplayName = (tier) => {
    const display = SUBSCRIPTION_PLANS_UPPERCASE[tier.split("__")?.[0]]?.displayName;
    return display ? this.props.t(display) : this.props.t(($) => $.admin["Custom"]);
  };

  getSubscriptionName = () => {
    axios.get(URL_PREFIX + "/api/aboutyourcompany").then((res) => {
      if (res.data.tier.startsWith("PRO") || res.data.tier.startsWith("CORE_PRO")) {
        this.setState(
          {
            subName: "Professional",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? 3 : 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("ENTER")) {
        this.setState(
          {
            subName: "Enterprise",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? 3 : 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("ENTREPREN") || res.data.tier.startsWith("CORE_ENTRE")) {
        this.setState(
          {
            subName: "Entrepreneur",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("CORE_GROWTH")) {
        this.setState(
          {
            subName: "Growth",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("BUSINESS")) {
        this.setState(
          {
            subName: "Business",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? 2 : 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("CORE_CUSTOM")) {
        this.setState(
          {
            subName: "Custom",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("CORPORATE")) {
        this.setState(
          {
            subName: "Corporate",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      }

      // Get pricing subscription name
      if (res.data.pricing_tier.startsWith("BUSINESS")) {
        this.setState(
          {
            pricingSubName: "Starter",
            currentPricingTier: res.data.pricing_tier,
            upgradedPricingSubscriptionPlanName: res.data.pricing_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.pricing_tier.startsWith("ENTER")) {
        this.setState(
          {
            pricingSubName: "Enterprise",
            currentPricingTier: res.data.pricing_tier,
            upgradedPricingSubscriptionPlanName: res.data.pricing_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.pricing_tier.startsWith("ENTREPREN")) {
        this.setState(
          {
            pricingSubName: "Entrepreneur",
            currentPricingTier: res.data.pricing_tier,
            upgradedPricingSubscriptionPlanName: res.data.pricing_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      }

      // Get analytics subscription name
      if (res.data.analytics_tier.startsWith("FREE")) {
        this.setState(
          {
            analyticsSubName: "Free",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.analytics_tier.startsWith("ENTER")) {
        this.setState(
          {
            analyticsSubName: "Enterprise",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.analytics_tier.startsWith("ENTREPREN")) {
        this.setState(
          {
            analyticsSubName: "Entrepreneur",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.analytics_tier.startsWith("PRO")) {
        this.setState(
          {
            analyticsSubName: "Professional",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      }
    });
  };

  extractSubscription() {
    const { currentTier, currentPricingTier } = this.state;
    const plan = currentTier.split("__");
    const pricingPlan = currentPricingTier?.split("__");
    if (plan[1] === "ANNUAL") {
      if (this.state.upgradeTarget === "pricing") {
        this.setState({
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedPricingSubscriptionPlanName: pricingPlan[0]?.annual?.["plan"],
          monthlyChecked: false,
        });
      } else if (this.state.upgradeTarget === "search-analytics") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedAnalyticsSubscriptionPlanName: pricingPlan[0]?.annual?.["plan"],
          monthlyChecked: false,
        });
      } else if (this.state.upgradeTarget === "content") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedContentSubscriptionPlanName: pricingPlan[0]?.annual?.["plan"],
          monthlyChecked: false,
        });
      } else {
        this.setState({
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: plan[1],
          payAmount: subscriptionPlans[plan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedSubscriptionPlanName: plan[0],
          monthlyChecked: false,
        });
      }
    } else if (plan[1] === "MONTHLY") {
      if (this.state.upgradeTarget === "pricing") {
        this.setState({
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.monthly["pay"],
          payPlan: subscriptionPlans[plan[0]]?.monthly["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.monthly["plan"],
          upgradedPricingSubscriptionPlanName: pricingPlan[0],
          monthlyChecked: true,
        });
      } else if (this.state.upgradeTarget === "search-analytics") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedAnalyticsSubscriptionPlanName: pricingPlan[0],
          monthlyChecked: true,
        });
      } else if (this.state.upgradeTarget === "content") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedContentSubscriptionPlanName: pricingPlan[0],
          monthlyChecked: true,
        });
      } else {
        this.setState({
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: plan[1],
          payAmount: subscriptionPlans[plan[0]]?.monthly["pay"],
          payPlan: subscriptionPlans[plan[0]]?.monthly["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.monthly["plan"],
          upgradedSubscriptionPlanName: plan[0],
          monthlyChecked: true,
        });
      }
    }
  }

  getSubscriptionList = () => {
    axios.get(URL_PREFIX + "/api/billing/subscription").then((res) => {
      this.setState({ subList: res.data.subscriptions.data });
    });
  };

  handleReactivateButton = () => {
    this.setState({ reactivateActive: true });
    const AuthHeader = "Bearer ".concat(this.props.auth.tokens.access_token);

    axios
      .post(
        URL_PREFIX + "/api/billing/subscription",
        {
          initialSubscriptionType: "advertising",
        },
        {
          params: {},
          headers: { Authorization: AuthHeader },
        },
      )
      .then((result) => {
        const { t } = this.props;
        if (result.error) {
          this.setState({
            error: {
              title: t(($) => $.admin["Card Declined"]),
              message: t(($) => $.admin["Payment failed. Please try adding a new active card."]),
            },
            reactivateActive: false,
          });
        }
        return result;
      })
      .then((result) => {
        const { t } = this.props;
        if (result.data.status === "User already subscribed.") {
          this.setState({
            error: {
              title: t(($) => $.admin["User Already Subscribed"]),
              message: t(($) => $.admin["Your organization is already subscribed."]),
            },
          });
          throw new Error("User already subscribed.");
        }

        if (result.data.status === "Subscription in retry state.") {
          localStorage.setItem("latestInvoiceId", result.data.invoice.id);
          localStorage.setItem("latestInvoicePaymentIntentStatus", result.data.invoice.payment_intent.status);

          this.retryInvoiceWithNewPaymentMethod();

          return {
            subscription: "break",
          };
        }

        if (result.data.subscription.status === "active" || result.data.subscription.status === "trialing") {
          this.setState({ subSuccessful: true });
          window.location.reload();
        }

        return {
          subscription: result,
        };
      })
      .then(this.handleRequiresPaymentMethod)
      .catch(() => {
        const { t } = this.props;
        this.setState({
          error: {
            title: t(($) => $.admin["Please try again"]),
            message: t(($) => $.admin["Something went wrong while updating subscription status."]),
          },
          reactivateActive: false,
        });
      });
  };

  handleRequiresPaymentMethod = ({ subscription }) => {
    const { t } = this.props;
    if (!(subscription === "break")) {
      const tempSubscription = subscription.data.subscription;
      if (
        tempSubscription.latest_invoice.payment_intent !== null &&
        tempSubscription.latest_invoice.payment_intent.status !== null
      ) {
        if (tempSubscription.latest_invoice.payment_intent.status === "requires_payment_method") {
          localStorage.setItem("latestInvoiceId", tempSubscription.latest_invoice.id);
          localStorage.setItem(
            "latestInvoicePaymentIntentStatus",
            tempSubscription.latest_invoice.payment_intent.status,
          );
          this.setState({
            error: {
              title: t(($) => $.admin["Payment Failed"]),
              message: t(($) => $.admin["Please try a new payment method."]),
            },
            reactivateActive: false,
          });
        }
      }
    }
  };

  retryInvoiceWithNewPaymentMethod() {
    const paymentInfo = {
      invoiceId: localStorage.getItem("latestInvoiceId"),
    };

    localStorage.removeItem("latestInvoiceId");
    localStorage.removeItem("latestInvoicePaymentIntentStatus");

    const AuthHeader = "Bearer ".concat(this.props.auth.tokens.access_token);

    return axios
      .post(URL_PREFIX + "/api/billing/retrysubscription", paymentInfo, {
        params: {},
        headers: { Authorization: AuthHeader },
      })
      .then((result) => {
        const { t } = this.props;
        if (result.error) {
          this.setState({
            error: {
              title: t(($) => $.admin["Improper Card Info"]),
              message: t(($) => $.admin["Please try a new payment method."]),
            },
          });
          throw result;
        }
        return result;
      })
      .then((result) => {
        const { t } = this.props;
        if (result.data.status === "User already subscribed.") {
          this.setState({
            error: {
              title: t(($) => $.admin["User Already Subscribed"]),
              message: t(($) => $.admin["Your organization is already subscribed"]),
            },
          });
          throw new Error("User already subscribed.");
        }

        if (result.data.subscription.status === "active" || result.data.subscription.status === "trialing") {
          this.setState({ subSuccessful: true });
          window.location.reload();
        }

        return {
          subscription: result,
        };
      })
      .then(this.handleRequiresPaymentMethod)
      .catch(() => {
        const { t } = this.props;
        this.setState({
          error: {
            title: t(($) => $.admin["Improper Card Info"]),
            message: t(($) => $.admin["Please try a new payment method."]),
          },
          reactivateActive: false,
        });
      });
  }

  render() {
    const { t } = this.props;
    const isActive =
      this.state.subList.length !== 0 &&
      this.props.amz_onboard.org_status !== "disconnected" &&
      !this.props.amz_onboard.remainder_days;

    const isCancelled =
      this.props.amz_onboard.org_status === "disconnected" ||
      this.props.amz_onboard.remainder_days !== null ||
      this.props.subscriptionCancelled;

    const isPaymentRequired = this.props.amz_onboard.org_status === "payment_required";

    const intervalToFrequency = (interval) => {
      if (interval === "month") return t(($) => $.admin["monthly"]);
      if (interval === "year") return t(($) => $.admin["yearly"]);
      if (interval === "week") return t(($) => $.admin["weekly"]);
      if (interval === "day") return t(($) => $.admin["daily"]);
      return interval + "ly";
    };

    return (
      <Card className={css({ paddingX: "large" })}>
        <VStack gap="medium" alignItems="stretch">
          <p className={css({ textAlign: "center", fontSize: "20px", fontWeight: 600 })}>
            {t(($) => $.admin["Plan Details"])}
          </p>

          {/* Active subscription */}
          {isActive && (
            <VStack gap="medium" alignItems="stretch" className={css({ fontSize: "14px" })}>
              {/* Tier line items */}
              <VStack gap="xsmall" alignItems="stretch">
                {this.props.user.tier && this.props.user.tier !== "unknown" && (
                  <HStack gap="xsmall" flexWrap="wrap">
                    <b>{this.getDisplayName(this.props.user.tier)}</b>
                    <span>{t(($) => $.admin["Advertising — since {date}"], { date: this.state.signUpDate })}</span>
                  </HStack>
                )}
                {this.props.user.pricing_tier && this.props.user.pricing_tier !== "unknown" && (
                  <HStack gap="xsmall" flexWrap="wrap">
                    <b>{this.getDisplayName(this.props.user.pricing_tier)}</b>
                    <span>{t(($) => $.admin["Dynamic Pricing"])}</span>
                  </HStack>
                )}
                {this.props.user.analytics_tier && this.props.user.analytics_tier !== "unknown" && (
                  <HStack gap="xsmall" flexWrap="wrap">
                    <b>{this.getDisplayName(this.props.user.analytics_tier)}</b>
                    <span>{t(($) => $.admin["Search Analytics"])}</span>
                  </HStack>
                )}
                {this.props.user.content_tier && this.props.user.content_tier !== "unknown" && (
                  <HStack gap="xsmall" flexWrap="wrap">
                    <b>{t(($) => $.admin["Standard"])}</b>
                    <span>{t(($) => $.admin["Content"])}</span>
                  </HStack>
                )}
              </VStack>

              {/* Key metrics grid */}
              <Grid columns={{ base: 1, sm: 2 }} gap="small" className={css({ fontSize: "13px" })}>
                <HStack gap="xsmall">
                  <strong>{t(($) => $.admin["Frequency:"])}</strong>
                  <span className={css({ textTransform: "capitalize" })}>
                    {intervalToFrequency(this.state.subList[0].items.data[0].plan.interval)}
                  </span>
                </HStack>
                <HStack gap="xsmall">
                  <strong>{t(($) => $.admin["You Pay:"])}</strong>
                  <span>
                    {formatCurrency(
                      this.state.subList[0].items.data.reduce(
                        (prev, subItem) => prev + (subItem.plan.amount * (subItem.quantity ?? 1)) / 100,
                        0,
                      ),
                      { marketPlace: "USA", decimalPlaces: 0 },
                    )}
                  </span>
                </HStack>
                {checkModule(this.props.modules, "SEARCH_ANALYTICS") && (
                  <HStack gap="xsmall">
                    <strong>{t(($) => $.admin["Shelf count:"])}</strong>
                    <span>
                      {this.state.numOfActiveShelves}/{this.state.currentNumOfShelves}
                    </span>
                  </HStack>
                )}
              </Grid>

              <Button
                onPress={() => this.setState({ changePlanModal: true })}
                className={css({ alignSelf: "center", width: "85%", maxWidth: "85%" })}
              >
                {t(($) => $.admin["Change Plan"])}
              </Button>
            </VStack>
          )}

          {/* Cancelled state */}
          {isCancelled && (
            <VStack gap="large" alignItems="center" className={css({ py: "xlarge" })}>
              <p className={css({ textAlign: "center", fontSize: "14px" })}>
                <Trans
                  ns="admin"
                  i18nKey={($) => $.admin["Your subscription is currently <b>cancelled</b>."]}
                  components={{ b: <b /> }}
                />
                {this.props.amz_onboard.remainder_days !== null && (
                  <span>
                    {" "}
                    {t(($) => $.admin["You have {days} paid days left."], {
                      days: this.props.amz_onboard.remainder_days,
                    })}
                  </span>
                )}
              </p>
              {!this.state.reactivateActive ?
                <Button onPress={() => this.handleReactivateButton()}>
                  {t(($) => $.admin["Reactivate with Trellis"])}
                </Button>
              : <img src={logo} alt={t(($) => $.common["Loading..."])} className="rotate" width="80" height="auto" />}
            </VStack>
          )}

          {/* Payment required warning */}
          {isPaymentRequired && (
            <div
              className={css({
                padding: "medium",
                borderRadius: "sm",
                backgroundColor: "fuchsia/5",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: 600,
              })}
            >
              {t(($) => $.admin["Your account requires a new payment method."])}
            </div>
          )}
        </VStack>

        {this.state.error.title !== undefined && (
          <ModalAlert
            title={this.state.error.title}
            msg={this.state.error.message}
            onClick={() => this.setState({ error: {} })}
          />
        )}

        <Modal
          isOpen={this.state.changePlanModal}
          onOpenChange={(isOpen) => {
            if (!isOpen) this.setState({ changePlanModal: false });
          }}
          title={t(($) => $.admin["Change Plan"])}
        >
          {this.state.loading ?
            <Loading height={"70vh"} fullPage={false} />
          : <VStack gap="large" alignItems="center" className={css({ padding: "medium" })}>
              <p className={css({ textAlign: "center" })}>
                {t(
                  ($) =>
                    $.admin["Please reach out to Trellis's customer success team to change your subscription plan."],
                )}
              </p>
              <Button
                onPress={() => {
                  window.location = "mailto:support@gotrellis.com";
                }}
              >
                {t(($) => $.admin["Contact Us"])}
              </Button>
            </VStack>
          }
        </Modal>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  marketPlace: state.marketPlace,
  amz_onboard: state.amz_onboard,
  user: state.user,
  modules: selectModules(state),
});

export default connect(mapStateToProps)(withRouter(withTranslation(["admin", "common"])(SubscriptionPlan)));
